<template>
  <div class="tw-w-full tw-relative" ref="target">
    <slot />
    <template v-if="mdAndUp">
      <div class="tw-bg-white tw-shadow-md tw-w-full tw-z-[999] tw-mt-1 tw-absolute tw-left-0" v-if="visible">
        <slot name="content" />
      </div>
    </template>
    <UIDialog v-else v-model="visible" :title="title" class="tw-modal-bottom" contentClass="tw-rounded-t-xl" :closable="closable" maskClosable>
      <slot name="content" />
    </UIDialog>
  </div>
</template>
<script setup lang="ts">
  const visible = defineModel<boolean>({ required: false })
  const target = ref(null)
  withDefaults(defineProps<{
    title?: string
    closable?:boolean
  }>(),{
    closable:true
  })

  const { mdAndUp } = useDisplay()

  onClickOutside(target, (event) => {
    visible.value = false
  })
</script>
